import styled from 'styled-components';
import media from '../../../styles/media';

export const BoardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${media.md`
  flex-direction: row;
  `};
`;

export const Board = styled.div`
  padding: 10px;
  background-color: ${props => props.theme.lightGray};
  overflow: auto;
  margin-bottom: 20px;

  ${media.md`
    width: calc(50% - 20px);
    margin: 0 10px;
  `};
`;

export const BoardItem = styled.div`
  width: 100%;
  margin-top: 10px;
  padding: 5px 10px;
  box-sizing: border-box;

  background-color: ${props => props.theme.white};
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.11);

  font-size: 16px;
  line-height: 26px;
  position: relative;

&.selected{
  &:before{
    content:'';
    position: absolute;
    left: 10px;
    top: 12px;
    width: 15px;
    height: 15px;
    background: ${props => props.theme.partpink};
  }

  &:after{
    content:'';
    border:2px solid white;
    border-left: none;
    border-top: none;
    position: absolute;
    left: 14px;
    top: 13px;
    width: 6px;
    height: 10px;
    transform: rotate(40deg);
  }

  span{
    padding-left: 25px;
    display:inline-block;
  }
}
`;

export const BoardItemPlaceholder = styled.div`
  width: 100%;
  height: 50px;
  margin-top: 10px;
  border: dashed 2px ${props => props.theme.gray};
`;

export default Board;
